import { render, staticRenderFns } from "./History.vue?vue&type=template&id=36bdd238&scoped=true&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"
import style0 from "./History.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./History.vue?vue&type=style&index=1&id=36bdd238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bdd238",
  null
  
)

export default component.exports